export const UserImg ="https://avatars.githubusercontent.com/u/47178017?v=4";

export const API_OPTIONS = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI4NTlhNjhlNmRmZDJjNzY5MTZmZWQ1NDljZjE3ZmE5YSIsInN1YiI6IjY1Zjk1ZjFkNGI5YmFlMDE4MzdlZDhjYiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.Pr9wFpvj-LpNIhwFiA_UO1I_ikndf9kjWmgBHY21PhQ'
    }
};

export const IMG_URL ="https://image.tmdb.org/t/p/w200"

export const BG_IMG_URL ="https://image.tmdb.org/t/p/original"
export const pp_IMG_URL ="https://image.tmdb.org/t/p/w92"
export const SUPPORTED_LANG = [{identifier: "en", name:"English"}, {identifier: "hindi", name:"Hindi"}, {identifier: "spanish", name:"Spanish"},{identifier:'kannada', name:"Kannada"}]


export const OPENAI_KEY ='cZSHzqUh0z';